// (A) 중립 InputNumber API — antd 미접촉. (B) PlainInputNumber 에 위임.
import type { CSSProperties } from 'react'
import { PlainInputNumber } from '../_impl/PlainInputNumber'

export interface OmwInputNumberProps {
  value?: number
  onChange?: (value: number | null) => void
  min?: number
  max?: number
  placeholder?: string
  disabled?: boolean
  className?: string
  style?: CSSProperties
}

export function OmwInputNumber(props: OmwInputNumberProps) {
  return <PlainInputNumber {...props} />
}
